module.exports = __webpack_public_path__ + "static/media/poster.9ef0e608.png";